import { jsx as _jsx } from "react/jsx-runtime";
import { getMessage } from './MESSAGE';
import { MessageKey } from './MessageKey';
import styled from 'styled-components';
const Messaging = styled.div.withConfig({
  displayName: "getMessageComponent__Messaging",
  componentId: "gkc2rx-0"
})(["", ""], props => props.messageKey === MessageKey.GenericLandingPage && `h4 {
      max-width: 270px;
      font-weight: 500;
      font-size: 22px;
      line-height: 30px;
    }`);
export const getMessageComponent = ({
  messageKey
}) => {
  const message = getMessage(messageKey);

  if (message) {
    const MessageComponent = message.component;

    if (MessageComponent) {
      return () => /*#__PURE__*/_jsx(Messaging, {
        "data-message-key": messageKey,
        messageKey: messageKey,
        children: /*#__PURE__*/_jsx(MessageComponent, {
          messageKey: messageKey
        })
      });
    }
  }

  return null;
};